import { ObservationEncounterActions } from "./ObservationEncounterActions";
import { useState } from "react";
import { ObservationEncounterVisualizer } from "./ObservationEncounterVisualizer";
import dayjs from "dayjs";
import { useOrganizationContext } from "../../../../../contexts/OrganizationContext";
import { EhrMobileGenericSection } from "../../mobile/EhrMobileGenericSection";

interface IProps {
  title: string;
  data: any;
  openVisualizer: any;
  verifyVisualizer: any;
}

export function ObservationsEncounter({
  title,
  data,
  openVisualizer,
  verifyVisualizer,
}: IProps) {
  const { organizationList } = useOrganizationContext();
  const [open, setOpen] = useState<boolean>(false);
  const [responseData, setResponseData] = useState();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      column: "Organização",
      rowName: "organization",
      width: "28%",
      lineClamp: 2,
    },
    { column: "Especialidade", rowName: "serviceType", width: "22%" },
    {
      column: "Profissional",
      rowName: "practitioner",
      width: "28%",
      lineClamp: 2,
    },
    { column: "Data", rowName: "date", width: "12%" },
  ];

  const rowData = data
    ?.filter((el: any) => el?.obs?.length)
    ?.map((el: any) => {
      const encounter = el.encounter;

      return {
        encounterId: el?.encounter?.id,
        organization:
          organizationList?.find((el: any) =>
            el.resource.id.includes(
              encounter?.serviceProvider.reference.split("/")[1]
            )
          )?.resource?.name ||
          encounter?.serviceProvider.reference.split("-")[1],
        serviceType:
          encounter?.serviceType?.find((el: any) =>
            el.reference?.reference?.includes("HealthcareService")
          )?.reference?.display || encounter?.class?.[0]?.coding?.[0]?.display,
        date: dayjs(encounter?.actualPeriod?.start).format("DD/MM/YYYY"),
        obs: el?.obs,
        practitioner:
          encounter?.participant
            ?.find((el: any) => el?.actor?.reference?.includes("Practitioner"))
            ?.actor?.display.toUpperCase() ||
          encounter?.participant?.find((el: any) =>
            el?.actor?.reference?.includes("Practitioner")
          )?.actor?.value ||
          encounter?.participant?.find((el: any) =>
            el?.actor?.type?.includes("Practitioner")
          )?.actor?.identifier?.value,
      };
    });

  return (
    <EhrMobileGenericSection
      title={title}
      columns={columns}
      rows={rowData ?? []}
      actions={(rowData: any) => (
        <ObservationEncounterActions
          verifyVisualizer={verifyVisualizer}
          row={rowData}
          openVisualizer={openVisualizer}
          handleOpen={handleOpen}
          setResponseData={setResponseData}
        />
      )}
      footer={
        open ? (
          <ObservationEncounterVisualizer
            data={responseData}
            handleClose={handleClose}
            isOpen={open}
          />
        ) : null
      }
    />
  );
}
